<template>
  <span :class="itemClass">
    <img v-if="isTarfinFlex === true" :src="flexLogo.src" :width="width" :height="flexLogo.height" alt="Tarfin" />
    <img v-else :src="`/images/logo-${alignment}.svg`" :width="width" :height="height" alt="Tarfin" />
  </span>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: 30
    },
    itemClass: {
      type: String,
      required: false
    },
    alignment: {
      type: String,
      default: 'vertical'
    },
    isTarfinFlex: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    flexLogo() {
      return this.alignment === 'single'
        ? { src: '/images/tarfin-flex-emblem.svg', height: 46 }
        : { src: '/images/tarfin-flex-logo.svg', height: 48 }
    }
  }
}
</script>
